import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

export default function NotFound() {
  const { t } = useApp();
  return (
    <div style={{ minHeight: 'calc(100vh - var(--nav-h))', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px 20px' }}>
      <div>
        <div style={{ fontSize: '80px', lineHeight: 1, marginBottom: '16px', filter: 'grayscale(0.3)' }}>🔍</div>
        <h1 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px' }}>Page not found</h1>
        <p style={{ color: 'var(--text3)', fontSize: '15px', marginBottom: '28px' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <Link to="/" className="btn btn-primary">Go home</Link>
          <Link to="/jobs" className="btn btn-outline">{t('nav_find_job')}</Link>
        </div>
      </div>
    </div>
  );
}
